'use strict'

import { createReducer } from '@dnamicro/controls/lib/utils/createReducer'

const INITIAL_STATE = {
  send_email: null,
  email_list: null,
  sending: false
}

const actionHandlers = {
  SEND_EMAIL: (state, action) => {
    return { ...state, send_email: action.payload, sending: false }
  },
  SEND_EMAIL_SUPPORT: (state, action) => {
    return { ...state, send_email: action.payload, sending: false }
  },
  EMAIL_LIST: (state, action) => {
    return { ...state, email_list: action.payload, sending: false }
  },
  SEND_EMAIL_REQUESTED: (state) => {
    return { ...state, sending: true }
  },
  EMAIL_LIST_REQUESTED: (state) => {
    return { ...state, sending: true }
  },
  CLEAR_EMAIL: (state) => {
    return { ...state, send_email: null, email_list: null, sending: false }
  }
}

export default createReducer(INITIAL_STATE, actionHandlers)



// WEBPACK FOOTER //
// ./src/redux/reducers/email.js